module.exports = __webpack_public_path__ + "static/images/nums-bg2.4905388.png";